import React, { useState, useEffect } from 'react';

interface MobileNavigationProps {
  children: React.ReactNode;
  title?: string;
}

const MobileNavigation: React.FC<MobileNavigationProps> = ({ children, title = "Navigation" }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Close navigation when clicking overlay
  const handleOverlayClick = () => {
    setIsOpen(false);
  };

  // Close navigation on escape key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      // Prevent body scroll when nav is open
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  return (
    <>
      {/* Mobile Navigation Toggle Button */}
      <button
        className="mobile-nav-toggle"
        onClick={() => setIsOpen(true)}
        aria-label="Open navigation menu"
        style={{
          display: 'block',
          background: 'none',
          border: 'none',
          fontSize: '1.5rem',
          cursor: 'pointer',
          padding: '0.5rem',
          borderRadius: '0.25rem',
          transition: 'background-color 0.2s',
        }}
      >
        ☰
      </button>

      {/* Mobile Navigation Overlay */}
      <div
        className={`mobile-nav-overlay ${isOpen ? 'active' : ''}`}
        onClick={handleOverlayClick}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1000,
          display: isOpen ? 'block' : 'none',
        }}
      />

      {/* Mobile Navigation Panel */}
      <div
        className={`mobile-nav-panel ${isOpen ? 'active' : ''}`}
        style={{
          position: 'fixed',
          top: 0,
          left: isOpen ? 0 : '-100%',
          width: '80%',
          maxWidth: '320px',
          height: '100vh',
          backgroundColor: 'white',
          zIndex: 1001,
          transition: 'left 0.3s ease',
          overflowY: 'auto',
          boxShadow: '2px 0 10px rgba(0, 0, 0, 0.1)',
        }}
      >
        {/* Navigation Header */}
        <div
          className="mobile-nav-header"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '1rem',
            borderBottom: '1px solid #e1e5e9',
          }}
        >
          <h3 style={{ margin: 0, fontSize: '1.125rem', fontWeight: '600' }}>
            {title}
          </h3>
          <button
            className="mobile-nav-close"
            onClick={() => setIsOpen(false)}
            aria-label="Close navigation menu"
            style={{
              background: 'none',
              border: 'none',
              fontSize: '1.5rem',
              cursor: 'pointer',
              padding: '0.25rem',
            }}
          >
            ✕
          </button>
        </div>

        {/* Navigation Content */}
        <div style={{ padding: '1rem' }}>
          {children}
        </div>
      </div>
    </>
  );
};

export default MobileNavigation;
